import { render, staticRenderFns } from "./EdenPageProgress.vue?vue&type=template&id=23e61d82"
import script from "./EdenPageProgress.vue?vue&type=script&lang=js"
export * from "./EdenPageProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports